/**
 * Asynchronously loads the component for DataPullRecordsPage
 */

import { lazyLoad } from 'utils/loadable';

export const CRMDataDumpRequestsPage = lazyLoad(
  () => import('./index'),
  module => module.CRMDataDumpRequests,
);
